import { render } from "./type-select.vue?vue&type=template&id=a7b2e8fe&scoped=true"
import script from "./type-select.vue?vue&type=script&lang=js"
export * from "./type-select.vue?vue&type=script&lang=js"

import "./type-select.vue?vue&type=style&index=0&id=a7b2e8fe&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b2e8fe"]])

export default __exports__